import { PropsWithChildren } from 'react'

import { StoreOfferProduct } from '@common'
import cx from 'classnames'

import { useHandleClick } from '@/features/storefronts/_storeBase/card/useHandleClick'
import { useSnowplowProductCardViewImpression } from '@/utils/snowplow'

import styles from './Container.module.scss'

type Props = PropsWithChildren<{
  product: StoreOfferProduct
}>

const snowplowId = 'CardBundle'

export const Container = ({ children, product }: Props) => {
  const productPageUrl = `/${product.game}/product/${product.slug}`
  const ref = useSnowplowProductCardViewImpression<HTMLAnchorElement>(product, snowplowId, snowplowId)
  const { handleClick } = useHandleClick({ product })

  return (
    <a href={productPageUrl} className={cx(styles.Container, styles[product.game])} onClick={handleClick} ref={ref}>
      {children}
    </a>
  )
}
